import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "@/i18n/LanguageContext";

// Cycles through translation keys with a springy slide.
export default function WordCycler({ keys = [], interval = 2200, className = "", testid = "word-cycler" }) {
  const { t } = useTranslation();
  const [i, setI] = useState(0);

  useEffect(() => {
    if (keys.length < 2) return undefined;
    const id = setInterval(() => setI((v) => (v + 1) % keys.length), interval);
    return () => clearInterval(id);
  }, [keys.length, interval]);

  const label = keys[i] ? t(keys[i]) : "";

  return (
    <span className="relative inline-flex items-baseline align-baseline" data-testid={testid}>
      <span className="invisible whitespace-nowrap">{label || "\u00a0"}</span>
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={keys[i] || i}
          className={`absolute left-0 inline-block whitespace-nowrap ${className}`}
          initial={{ y: "0.75em", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "-0.6em", opacity: 0 }}
          transition={{ type: "spring", stiffness: 220, damping: 24 }}
        >
          {label}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
